import { render, staticRenderFns } from "./TodaysBid.vue?vue&type=template&id=4869f27c&"
import script from "./TodaysBid.vue?vue&type=script&lang=js&"
export * from "./TodaysBid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports